import { Component } from '@angular/core';
import { CMSLanguageService } from '@markant-platform/shared/data-access';
import { ActivatedRoute } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { CmsPage } from '@markant-platform/shared/content/model';
import { ContentService } from '@markant-platform/shared/content/data-access';

@Component({
  selector: 'markant-platform-cms-page-static',
  templateUrl: './cms-page-static.component.html',
  styleUrls: ['./cms-page-static.component.scss'],
})
export class CmsPageStaticComponent {
  page$?: Observable<CmsPage>;

  constructor(
    private contentService: ContentService,
    private route: ActivatedRoute,
    private cmsLanguageService: CMSLanguageService
  ) {
    const pageId = this.route.snapshot.queryParams['pageId'];

    if (pageId) {
      this.page$ = this.cmsLanguageService.activeCMSLanguage$.pipe(
        switchMap(() => this.contentService.getCmsPageStatic(parseInt(pageId)))
      );
    }
  }
}
